<eca-app-document-results-table [sessionId]="sessionId"></eca-app-document-results-table>
